import React from 'react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'

import styles from './CommentThreadCard.module.sass'
import RecipientsNotified from 'context/Drawer/drawers/CommentThread/RecipientsNotified'

const InlineCommentReply = ({ reply }) => {
	const {
		author,
		date,
		body,
		isInternalNote,
		hasFiles,
		filesOptions,
		providerEstablishment,
		notifiedEntities,
		notifiedEstablishments,
	} = reply

	const { openFile } = useGlobal()

	if (isInternalNote) {
		return (
			<div className={styles['inline-reply']}>
				<div className={styles['inline-reply-note']}>
					<Icon
						name='note'
						width='14px'
						height='14px'
						className={styles['inline-reply-note-icon']}
					/>
					<small>{body}</small>
				</div>
			</div>
		)
	}

	return (
		<div className={styles['inline-reply']}>
			<HStack
				className={styles['inline-reply-layout']}
				align='stretch'
				gap='small'
			>
				<span className={styles['inline-reply-avatar']}>
					<Avatar rounded user={author} />
				</span>
				<VStack className={styles['inline-reply-info']}>
					{providerEstablishment?.name && (
						<Tooltip text={providerEstablishment.name}>
							<small
								className={styles['inline-reply-establishment']}
							>
								{providerEstablishment.name}
							</small>
						</Tooltip>
					)}
					<HStack
						className={styles['inline-reply-date-row']}
						align='center'
					>
						{date?.dateTimeFormat && (
							<Tooltip
								displayDelay={600}
								alwaysBelow
								content={
									<RecipientsNotified
										notifiedEntities={notifiedEntities}
										notifiedEstablishments={
											notifiedEstablishments
										}
									/>
								}
							>
								<small className={styles['inline-reply-date']}>
									<Icon
										name='calendar'
										width='12px'
										height='12px'
										className={
											styles['inline-reply-date-icon']
										}
									/>
									{date.dateTimeFormat}
								</small>
							</Tooltip>
						)}
						{hasFiles && (
							<ModalOptions
								title='Documents'
								options={filesOptions}
								centerArrow
								fixedHeight='auto'
								alwaysAbove
								selectable={false}
								onSelect={(e) => {
									openFile && openFile(e)
									return true
								}}
							>
								<Icon
									name='attachment'
									width='14px'
									height='14px'
									className={
										styles['inline-reply-attachment']
									}
								/>
							</ModalOptions>
						)}
					</HStack>
				</VStack>
				<div className={styles['inline-reply-body']}>{body}</div>
			</HStack>
		</div>
	)
}

export default InlineCommentReply
